import { GetApp, OpenInNew } from "@material-ui/icons";
import React from "react";
import "./Stories.scss";
import moment from "moment/moment";
import black from "../../icons/default3.png";
import { useHistory } from "react-router-dom";

export type FeedbackType = {
    id: string;
    title: string;
    avatar: string;
    updatedAt: Date;
};

type Props = {
    feedback: FeedbackType[];
    onDownload: (id: string) => any;
};

export function mapToFeedback(data: { [key: string]: any }): FeedbackType {
    return {
        id: data.id,
        title: data.title,
        avatar: data.cover_image,
        updatedAt: new Date(data.updated_at * 1000),
    };
}

const Feedback: React.FC<Props> = ({ feedback, onDownload }) => {
    const history = useHistory();
    return (
        <React.Fragment>
            {feedback.map((draft, index) => (
                <div className="draft">
                    <div className="image">
                        <img
                            src={
                                draft.avatar.trim() !== ""
                                    ? draft.avatar
                                    : black
                            }
                        />
                    </div>
                    <div className="content">
                        <h5>
                            {draft.title.length > 80
                                ? draft.title.substr(0, 80) + "..."
                                : draft.title}
                        </h5>
                        <p>
                            Last updated on{" "}
                            {moment(draft.updatedAt).format(
                                "Do MMMM YYYY [at] h:mm a"
                            )}
                        </p>
                        <div className="action">
                            <button
                                onClick={() => onDownload(draft.id)}
                                style={{ marginRight: 4 }}
                            >
                                <GetApp />
                                Download Report
                            </button>
                            <button
                                onClick={() =>
                                    history.push("/writer/feedback/" + draft.id)
                                }
                            >
                                <OpenInNew />
                                View Feedback
                            </button>
                        </div>
                    </div>
                </div>
            ))}
        </React.Fragment>
    );
};

export default Feedback;
